export default __webpack_public_path__ + "static/media/earphones12.1e82805f.jfif";